import asyncComponent from '../common/utils/async-component.js';

const ContentSearchContainer = asyncComponent(async () => import('./components/list/index.js'));
const ContentEdit = asyncComponent(async () => import('./components/site-edit/index.js'));

export default {
  '/sites': {
    components: { main: ContentSearchContainer },

    '/create': {
      components: { main: ContentEdit }
    },
    '/:contentId': {
      components: { main: ContentEdit }
    }
  }
};
